import {
  imgproxySettings,
  mobileImgproxySettings,
  resolveLifestyleOptionsFromSKU as resolveOptionsFromSKU,
  stripMatteOrInfinitePrefix,
} from './shared.mjs'

export const frame = {
  id: 'frame',
  name: 'Frame',
  imgproxySettings,
  mobileImgproxySettings,
  options: {
    clear: {
      pathTemplate: 'gs://sg360/250725/tokas/tkf_Fclear_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250725/tokas/tkf_Fclear_{nnn}.png',
    },
    black: {
      pathTemplate: 'gs://sg360/250725/tokas/tkf_Mblack_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250725/tokas/tkf_Mblack_{nnn}.png',
    },
    blacktortoise: {
      pathTemplate: 'gs://sg360/250725/tokas/tkf_Mblacktortoise_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250725/tokas/tkf_Mblacktortoise_{nnn}.png',
    },
    grey: {
      pathTemplate: 'gs://sg360/250725/tokas/tkf_Mgrey_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250725/tokas/tkf_Mgrey_{nnn}.png',
    },
    navy: {
      pathTemplate: 'gs://sg360/250725/tokas/tkf_Mnavy_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250725/tokas/tkf_Mnavy_{nnn}.png',
    },
    tortoise: {
      pathTemplate: 'gs://sg360/250725/tokas/tkf_Mtortoise_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250725/tokas/tkf_Mtortoise_{nnn}.png',
    },
    fblue: {
      pathTemplate: 'gs://sg360/250314/sg11f_Fblue_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250314/sg11f_Fblue_{nnn}.png',
    },
    desertsand: {
      pathTemplate: 'gs://sg360/260311/tof_Idesertsand--{nnn}.png',
      staticPathTemplate: 'gs://sg360/260311/tof_Idesertsand--{nnn}.png',
    },
    glacierblue: {
      pathTemplate: 'gs://sg360/260311/tof_Iglacierblue--{nnn}.png',
      staticPathTemplate: 'gs://sg360/260311/tof_Iglacierblue--{nnn}.png',
    },
  },
}

export const logos = {
  id: 'logos',
  name: 'Logos',
  imgproxySettings,
  mobileImgproxySettings,
  options: {
    Bblack: {
      pathTemplate: 'gs://sg360/250725/tokas/tki_black_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250725/tokas/tki_black_{nnn}.png',
    },
    Bblue: {
      pathTemplate: 'gs://sg360/250725/tokas/tki_blue_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250725/tokas/tki_blue_{nnn}.png',
    },
    Bgold: {
      pathTemplate: 'gs://sg360/250725/tokas/tki_gold_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250725/tokas/tki_gold_{nnn}.png',
    },
    Bgunmetal: {
      pathTemplate: 'gs://sg360/250725/tokas/tki_gunmetal_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250725/tokas/tki_gunmetal_{nnn}.png',
    },
    Bsilver: {
      pathTemplate: 'gs://sg360/250725/tokas/tki_silver_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250725/tokas/tki_silver_{nnn}.png',
    },
    Bwhite: {
      pathTemplate: 'gs://sg360/250725/tokas/tki_white_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250725/tokas/tki_white_{nnn}.png',
    },
  },
}

export const lenses = {
  id: 'lens',
  name: 'Lenses',
  imgproxySettings,
  mobileImgproxySettings,
  options: {
    blue: {
      pathTemplate: 'gs://sg360/250725/tokas/tkle_blue_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250725/tokas/tkle_blue_{nnn}.png',
    },
    chrome: {
      pathTemplate: 'gs://sg360/250725/tokas/tkle_chrome_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250725/tokas/tkle_chrome_{nnn}.png',
    },
    fire: {
      pathTemplate: 'gs://sg360/250725/tokas/tkle_fire_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250725/tokas/tkle_fire_{nnn}.png',
    },
    gold: {
      pathTemplate: 'gs://sg360/250725/tokas/tkle_gold_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250725/tokas/tkle_gold_{nnn}.png',
    },
    silverblue: {
      pathTemplate: 'gs://sg360/250725/tokas/tkle_silverblue_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250725/tokas/tkle_silverblue_{nnn}.png',
    },
    smoke: {
      pathTemplate: 'gs://sg360/250725/tokas/tkle_smoke_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250725/tokas/tkle_smoke_{nnn}.png',
    },
    clear: {
      pathTemplate: 'gs://sg360/270624/Tokas/tole/tole_clear_{nnn}.png',
      staticPathTemplate: 'gs://sg360/270624/Tokas/tole/tole_clear_{nnn}.png',
    },
    brown: {
      pathTemplate: 'gs://sg360/250804/tkle_brown_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250804/tkle_brown_{nnn}.png',
    },
    grn: {
      pathTemplate: 'gs://sg360/260311/tole_Ngrn--{nnn}.png',
      staticPathTemplate: 'gs://sg360/260311/tole_Ngrn--{nnn}.png',
    },
  },
}

export const engraving = {
  id: 'engraving',
  name: 'Engraving',
  imgproxySettings,
  mobileImgproxySettings,
  options: {
    eN: {
      pathTemplate: 'gs://sg360/050623/Tokas/tolg/tolg_N_{nnn}.png',
    },
    eP: {
      pathTemplate: 'gs://sg360/050623/Tokas/tolg/tolg_P_{nnn}.png',
    },
    e8: {
      pathTemplate: 'gs://sg360/050623/Tokas/tolg/tolg_8P_{nnn}.png',
    },
    e8P: {
      pathTemplate: 'gs://sg360/050623/Tokas/tolg/tolg_8_{nnn}.png',
    },
    none: {
      disabled: true,
    },
  },
}

export const background = {
  id: 'background',
  name: 'Background',
  imgproxySettings: ['insecure', 'resize:fill:1400', 'plain'],
  mobileImgproxySettings: ['insecure', 'resize:fill:800', 'plain'],
  isBackground: true,
  options: {
    default: {
      pathTemplate: 'gs://sg360/250725/tokas/tkf_shadow_{nnn}.png',
    },
  },
}

export function resolveOptions(customisedProduct) {
  const engraving =
    {
      '4ko': 'eN',
      '4kop': 'eP',
      '8ko': 'e8',
      '8kop': 'e8P',
    }[customisedProduct.lensTech] || 'none'

  return {
    frame: stripMatteOrInfinitePrefix(customisedProduct.frameChoice?.skuWithoutPrefix),
    lens: customisedProduct.lensChoice.skuWithoutLensTech.split('_')?.slice(1)?.join('_'),
    logos: customisedProduct.iconChoice?.sku?.split('_')?.slice(1)?.join('_'),
    engraving,
  }
}

export default {
  layers: [background, frame, logos, lenses, engraving],
  resolveOptions,
  resolveOptionsFromSKU,
}
